
define('text!modules/util/collection/list_items_template.html',[],function () { return '<ul class="collection"></ul>\r\n';});

